// extracted by mini-css-extract-plugin
module.exports = {"header":"CompanyOverviewTab_header__2of--","headerWrapper":"CompanyOverviewTab_headerWrapper__9FPXz"};